var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text || _vm.info)?_c('ScacInfo',{attrs:{"items":_vm.infoItems}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }